import { ListedRoom } from '../../../components/scenario/room';
import { useColors } from '../../../common/chat/userColors';
import { ScenarioWithRooms, ScenarioWithRoomsAndStages } from '../../../common/types';
import { useMembers } from '../../../components/scenario/members';
import { ShareButton } from '../../../components/ShareButton';
// import { useCode } from '../../../components/user/CodeContext';
import { StageGraph } from '../../../components/stages/StageGraph';
import { LeaderboardButton } from '../../../components/LeaderboardButton';

export type ScenarioViewProps = {
  scenario: ScenarioWithRoomsAndStages;
};

export function ScenarioView(props: ScenarioViewProps) {
  // const { code } = useCode();
  const scenario = props.scenario;
  const rooms = scenario.rooms;

  // Assign colors to members
  const members = useMembers(rooms);
  const memberColors = useColors(members);

  return (
    <div className="home-page bg-[#101c2c] text-white font-sans flex flex-col h-dvh fade-in-component">
      <div className="flex flex-col flex-grow min-h-0 p-4 lg:p-6 lg:max-w-6xl mx-auto">
        {/* Top Section with Image and Text */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
          {/* Left Column: Image */}
          <div className="flex justify-center items-start">
            <img
              src={scenario.image}
              alt={`${scenario.name} Initial Scene`}
              className="w-full max-w-[512px] max-h-[512px] lg:max-w-none lg:max-h-none rounded-lg object-cover"
            />
          </div>

          {/* Right Column: Name and Description */}
          <div className="flex flex-col justify-end space-y-4">
            <div className="flex items-center justify-between gap-4">
              <h1 className="text-4xl font-bold">{scenario.name}</h1>
            </div>
            <div className="flex items-left gap-4">
              <ShareButton />
              <LeaderboardButton scenarioUuid={scenario.scenarioUuid} />
            </div>
            <p className="text-gray-400 text-lg">{scenario.description}</p>
            {scenario.stages.length > 0 ? <StageGraph stages={scenario.stages} /> : null}
          </div>
        </div>

        {/* Rooms Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {rooms.length > 0 ? (
            rooms.map((room) => (
              <ListedRoom key={room.uuid} room={room} memberColors={memberColors} />
            ))
          ) : (
            <p className="text-gray-400">No rooms available.</p>
          )}
        </div>
        <div className="pb-4 lg:p-6" />
      </div>
    </div>
  );
}
